<template>
	<!-- Copied this from base project since <style> block was ignored in production upon client-side rendering (checkout ssr did work!)
		and led to the incorrect styling in production csr only.
	 	Caused by a bundler bug.
	 -->
    <div class="datepicker-base">
        <fieldset :name="label">
            <legend v-if="label" class="datepicker-base__legend">{{ label }}</legend>

            <div class="datepicker-base__inputs">
                <input type="number" :placeholder="$t('Generic.year', null, 1)" :name="$t('Generic.year', null, 1)"
                       v-model.lazy.number="year" @change="checkDaySelection"
					   :disabled="disabled"
                       class="form-control input-gray datepicker-base__year" :required="required" :max="maxYear" min="1900">

                <select
                    v-model="month"
                    :name="$t('Generic.month')"
                    class="form-control input-gray custom-select datepicker-base__month"
                    @change="checkDaySelection"
                    :required="required"
					:disabled="disabled"
                >
                    <option value="" disabled>{{ $t('Generic.month') }}</option>
                    <option v-for="month in 12" :key="month" :value="month">
                        {{ month }}
                    </option>
                </select>

                <select v-model="day" class="form-control input-gray custom-select datepicker-base__day"
                        :name="$t('Generic.day', null, 1)"
                        :required="required"
						:disabled="disabled"
						@change="checkDaySelection">
                    <option value="" disabled>{{ $t('Generic.day', null, 1) }}</option>
                    <option v-for="day in days" :key="day" :value="day">
                        {{ day }}
                    </option>
                </select></div>
        </fieldset>
    </div>
</template>

<script>

export default {
    name: 'DateInput',

    model: {
        prop: 'value',
        event: 'change'
    },

    data() {
        const t = this.$t;
        return {
            year: null,
            month: '',
            day: ''
        }
    },

    props: {
        value: {
            required: true
        },

        label: {
            type: String
        },

        required: Boolean,
		disabled: Boolean,

        allowFutureDates: Boolean
    },

    computed: {
        maxYear() {
            if (this.allowFutureDates) {
                return undefined;
            }
            return (new Date()).getFullYear();
        },

        days() {
            const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            const isLeapYear = this.year % 400 === 0 || (this.year % 100 !== 0 && this.year % 4 === 0);
            if (isLeapYear) {
                monthLength[1] = 29;
            }
            return monthLength[this.month - 1] || 31;
        },

        inputsCombined() {
            const {year, month, day} = this;
            if (year && month && day) {
                return `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`;
            }
            return null;
        },


    },

    methods: {
        /**
         * While browser clears select element if selected option is gone, it's v-model caches the old value
         * Reproduction use case: select March 31, then February. Day select v-model won't be cleared
         */
        checkDaySelection() {
            if (this.days < this.day) {
                this.day = '';
            }
        }
    },

    watch: {
        // not using computed as this one produces side effects
        value: {
            handler(value) {
                if (value && typeof value === 'string' && value.trim().length === 10) {
                    const [day, month, year] = value.split('.');
                    if (!isNaN(day)) {
                        this.day = +day;
                    }
                    if (!isNaN(month)) {
                        this.month = +month;
                    }
                    if (!isNaN(year)) {
                        this.year = +year;
                    }
                }
            },
            immediate: true
        },

        inputsCombined(value) {
            this.$emit('change', value);
        }
    }

}
</script>

<style scoped lang="scss">
.datepicker-base {
    &__inputs {
        display: flex;
        gap: .5rem;
    }

    &__legend {
        font-size: 0.875rem;
    }

    &__year {
        width: calc(6ch + 30px)
    }

    &__day {
        width: calc(4ch + 30px)
    }

    &__month {
        width: max-content;
    }
}
</style>
